export default __webpack_public_path__ + "static/media/024-Abraham Lincoln.593d1af8.svg";